module.exports = __webpack_public_path__ + "static/media/14a-03_ST-2014-130x95cm-oleo-y-aceite-de-lino-sobre-papel.678a7b8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/14a/14a-03_ST-2014-130x95cm-oleo-y-aceite-de-lino-sobre-papel.jpg
// module id = 146
// module chunks = 0